import omit from 'lodash/omit';
import set from 'lodash/fp/set';

import {
  ADD_CART_ITEM_REQUEST,
  ADD_CART_ITEM_RESPONSE,
  ADD_CART_ITEM_ERROR,
  REMOVE_CART_ITEM_REQUEST,
  REMOVE_CART_ITEM_RESPONSE,
  REMOVE_CART_ITEM_ERROR,
  UPDATE_CART_ITEM_RESPONSE,
  CREATE_CART_RESPONSE,
  GET_CART_RESPONSE,
  CREATE_CHECKOUT_RESPONSE,
} from 'actions/pantry';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CART_RESPONSE:
    case UPDATE_CART_ITEM_RESPONSE:
    case REMOVE_CART_ITEM_RESPONSE:
    case ADD_CART_ITEM_RESPONSE:
    case GET_CART_RESPONSE:
      return {
        ...state,
        ...action.response.pantryCart.lineItems,
      };
    case ADD_CART_ITEM_REQUEST:
      return set(
        action.params.lineItem.productId,
        { id: '', krogerId: action.params.lineItem.productId, quantity: 1 },
        state
      );
    case ADD_CART_ITEM_ERROR:
    case REMOVE_CART_ITEM_REQUEST:
      return omit(state, action.params.lineItem.productId);
    case REMOVE_CART_ITEM_ERROR:
      return set(
        action.params.lineItem.productId,
        {
          id: action.params.lineItem.id,
          krogerId: action.params.lineItem.productId,
          quantity: action.params.lineItem.quantity,
        },
        state
      );
    case CREATE_CHECKOUT_RESPONSE:
      return initialState;
    default:
      return state;
  }
};
